import { useLocation, Link } from 'react-router-dom';
import { identity } from '@repletoryreach/sdk-api';
import { useAuth } from '@repletoryreach/sdk-auth';
import { Button, Card, Stack, Title, Text } from '@repletoryreach/sdk-ui';
import { useT } from '../../i18n/I18nProvider';
import { adminOnlyPrefixes } from '../../lib/nav';
import { SETTINGS_NAV } from '../../pages/settings/nav';

/** Whether the signed-in person may use owner-and-admin pages. A missing role (an older session) is not taken as agent. */
export function useIsOrgAdmin(): boolean {
  const { user } = useAuth();
  return user?.role == null || identity.isOrgAdmin(user.role);
}

const SETTINGS_ADMIN = SETTINGS_NAV.flatMap((s) => s.items).filter((i) => i.adminOnly).map((i) => i.path);

/**
 * Agents (roles, 2 October 2026) do not see the owner-and-admin pages in the
 * menus; one opened by its address shows this notice instead of a page whose
 * every action the services would refuse anyway.
 */
export function RoleGate({ children }: { children: React.ReactNode }) {
  const t = useT();
  const { pathname } = useLocation();
  const admin = useIsOrgAdmin();
  if (admin) return <>{children}</>;
  const blocked = [...adminOnlyPrefixes(), ...SETTINGS_ADMIN].some((p) => pathname === p || pathname.startsWith(`${p}/`));
  if (!blocked) return <>{children}</>;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 16px' }}>
      <Card withBorder style={{ maxWidth: 560, width: '100%' }}>
        <Stack gap="sm">
          <Title order={3}>{t('roles.gate.title')}</Title>
          <Text role="bodySmall">{t('roles.gate.body')}</Text>
          <div><Link to="/inbox"><Button size="sm">{t('roles.gate.toInbox')}</Button></Link></div>
        </Stack>
      </Card>
    </div>
  );
}
